import { useQuery } from "@tanstack/react-query";
import studentApi from "../../api/studentApi";

export const useGetStudentOfYear = (params : any) => {
    return useQuery({
        queryKey: ["student-of-year", params],
        queryFn: () => studentApi.getTotalStudentOfYear(params),
    });
};
